import React, {Component} from 'react'

import LibField from 'lib/struct/Field'

import styles from './Field.less'

export default class Field extends Component {
    render() {
        const {children, ...props} = this.props

        return (
            <LibField
                {...props}
                labelClass={styles['label']}
            >
                {children}
            </LibField>
        )
    }
}
